import React from "react";

export default function PCMainSkeleton() {
  return (
    <div  className="global-content" style={{zIndex:1}}>
      <div className="global-left">
        <div className="global-left-item skeleton_loading"></div>
        <div className="global-left-item skeleton_loading"></div>
        <div className="global-left-item skeleton_loading"></div>
      </div>
      <div className="global-center">
        <div className="global-center-title skeleton_loading"></div>
        <div className="global-center-tag">
          <div className="global-center-tag-item skeleton_loading"></div>
          <div className="global-center-tag-item skeleton_loading"></div>
          <div className="global-center-tag-item skeleton_loading"></div>

        </div>
        <div className="global-center-list">
          <div className="global-center-list-item skeleton_loading"></div>
          <div className="global-center-list-item skeleton_loading"></div>
          <div className="global-center-list-item skeleton_loading"></div>
          <div className="global-center-list-item skeleton_loading"></div>
          <div className="global-center-list-item skeleton_loading"></div>
          <div className="global-center-list-item skeleton_loading"></div>
          <div className="global-center-list-item skeleton_loading"></div>
          <div className="global-center-list-item skeleton_loading"></div>
          <div className="global-center-list-item skeleton_loading"></div>
        </div>
        <div className="global-center-btn skeleton_loading"></div>

      </div>
      <div className="global-right">
        <div className="global-right-content">
          <div className="global-right-card skeleton_loading"></div>
          <div className="global-right-list">
            <div className="global-right-item skeleton_loading"></div>
            <div className="global-right-item skeleton_loading"></div>
            <div className="global-right-item skeleton_loading"></div>
            <div className="global-right-item skeleton_loading"></div>
            <div className="global-right-item skeleton_loading"></div>
          </div>
        </div>
      </div>
    </div>
  );
}